<mat-toolbar>
  <span>Angular Material Facet Toolkit: v{{version}}</span>
  <span class="spacer"></span>
  <a mat-button routerLink="" [color]="activePage === 'one' ? 'primary' : ''">
    Page One
  </a>
  <a mat-button routerLink="/two" [color]="activePage === 'two' ? 'primary' : ''">
    Page Two
  </a>
  <a mat-button routerLink="/theme" [color]="activePage === 'three' ? 'primary' : ''">
    Theme Lab
  </a>
  <button mat-button (click)="toggleTheme()">
    <mat-icon>{{ isDarkMode ? 'light_mode' : 'dark_mode' }}</mat-icon>
    {{ isDarkMode ? 'Light mode' : 'Dark mode' }}
  </button>
  <span class="spacer"></span>
  <a [href]="repo" target="_blank" mat-stroked-button>View on GitHub</a>
</mat-toolbar>

<div fxLayout="column" class="container">
  <router-outlet></router-outlet>
</div>
